var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18a8 8 0 118-8 8 8 0 01-8 8zm0-14.667A6.667 6.667 0 1016.667 10 6.667 6.667 0 0010 3.333zm.36 8.334h-.717a.338.338 0 01-.34-.316l-.305-5.667a.337.337 0 01.34-.35h1.326a.337.337 0 01.34.35l-.304 5.667a.338.338 0 01-.34.316zm-.362 1a1 1 0 11-1 1 1 1 0 011-1z",
    fill: "#C44A36"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default ForwardRef;